import React, {useState} from 'react';
import { NavLink } from 'react-router-dom';
import {Layout, Menu} from 'antd';
import { EyeOutlined, UserOutlined, ProfileOutlined, GithubOutlined } from '@ant-design/icons';

const { SubMenu } = Menu;
const { Sider } = Layout;

const MenuComponent = ({}) => {
    const [current, setCurrent] = useState('1');

    const handleClick = e => {
        setCurrent(e.key);
    };

        return (
            <Sider width={300}>
                <div>
                    <img className="logo" alt="Logo" src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601233559/documentation/logo-rs-school_z1jyxr.png"/>
                </div>
                <Menu
                    theme="dark"
                    onClick={handleClick}
                    defaultOpenKeys={['sub1']}
                    selectedKeys={[current]}
                    mode="inline"
                >
                    <Menu.Item key="1" icon={<EyeOutlined />}>
                        <NavLink to={'/'}>
                        Описание
                        </NavLink>
                    </Menu.Item>
                    <SubMenu key="sub2" icon={<ProfileOutlined />} title="Документация">
                        <Menu.Item key="2"><NavLink to={'/docs/start'}>Начало работы</NavLink></Menu.Item>
                        <Menu.Item key="3"><NavLink to={'/docs/backend'}>Серверная часть</NavLink></Menu.Item>
                        <Menu.Item key="4"><NavLink to={'/docs/design'}>Дизайн</NavLink></Menu.Item>
                        <SubMenu key="sub3" title="Основные компоненты">
                            <Menu.Item key="5"><NavLink to={'/docs/components/table'}>Таблица</NavLink></Menu.Item>
                            <Menu.Item key="6"><NavLink to={'/docs/components/calendar'}>Календарь</NavLink></Menu.Item>
                            <Menu.Item key="7"><NavLink to={'/docs/components/list'}>Список</NavLink></Menu.Item>
                            <Menu.Item key="10"><NavLink to={'/docs/components/taskpage'}>Страница задания</NavLink></Menu.Item>
                            <Menu.Item key="9"><NavLink to={'/docs/components/forms'}>Формы</NavLink></Menu.Item>
                        </SubMenu>
                        <SubMenu key="sub4" title="Фичи">
                            <Menu.Item key="11"><NavLink to={'/docs/features/preferences'}>Настройки пользователя</NavLink></Menu.Item>
                            <Menu.Item key="12"><NavLink to={'/docs/features/dark'}>Темная тема</NavLink></Menu.Item>
                        </SubMenu>
                    </SubMenu>
                    <Menu.Item icon={<GithubOutlined />} key="13"><NavLink to={'/libraries'}>Библиотеки</NavLink></Menu.Item>
                    <Menu.Item icon={<UserOutlined />} key="14"><NavLink to={'/authors'}>Авторы</NavLink></Menu.Item>
                </Menu>
            </Sider>
        );
};

export default MenuComponent;